import {registry} from './registry';

export function getModule(name, opts = {silent: false}) {
    if (registry.contains(name)) {
        return registry.get(name);
    } else if (!opts.silent) {
        Hop.logError(new Error(`No module "${name}" defined`));
    }
}
